<template>
  <div class="shoppe" v-loading.fullscreen.lock="fullscreenLoading">
    <el-input v-model="title" placeholder="标题" :readonly="isShow" :disabled="isEdit" :maxlength="30" style="width: 100%">
      <el-button slot="append" @click="importWord">导入Word</el-button>
    </el-input>
    <input ref="wordInput" class="file-input" @change="changeWordFile" accept=".doc,.docx" type="file">

    <quill-editor class="mt20" ref="myQuillEditor" v-model="content" :options="editorOption" />
    <input ref="fileInput" class="file-input" @change="changeFile" multiple accept=".jpg,.jpeg,.png,.gif" type="file">

    <el-radio-group class="mt20" :disabled="isShow || (isEdit && !editDateEnable)" v-model="releaseStatus">
      <el-radio :label="2">立即发布</el-radio>
      <el-radio :label="1">定时发布</el-radio>
    </el-radio-group>
    <div class="mt20" v-if="releaseStatus == 1">
      选择发布时间：
      <el-date-picker
        v-model="releaseDate"
        type="datetime"
        :readonly="isShow || (isEdit && !editDateEnable)"
        format="yyyy-MM-dd HH:mm"
        value-format="timestamp"
        placeholder="选择发布时间">
      </el-date-picker>
    </div>
    <div class="mt20">
      <el-cascader
        v-model="sellerHouseRuleSectorId"
        :options="sellerHouseRuleSectorList"
        :props="{ expandTrigger: 'hover', emitPath: false }"
        @change="sectorChange"
        placeholder="请选择规则板块"
        :disabled="isShow || isEdit"
      ></el-cascader>
    </div>

    <div class="mt20">
      <el-button @click="$router.back()">返回</el-button>
      <el-button type="primary" v-if="!isShow" @click="submit">发布</el-button>
      <el-button type="primary" plain @click="preview">预览</el-button>
    </div>

    <el-dialog title="预览" :visible.sync="dialogVisible" width="375px">
      <h1 class="title">{{ title }}</h1>
      <div class="preview-bulletin" v-html="content"></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Quill from 'quill'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import TableModule from 'quill1-table';
import Client from "@/utils/client.js"
import utils from '@/utils/util';

Quill.register('modules/table', TableModule);

import {
  fileUpload,
  addOrUpdateNotice,
  getNoticeDetail,
  getRuleDetail,
  ruleSave,
  getRuleSectorList,
  docxToHtml,
} from "./api";

export default {
  components: {
    quillEditor,
  },
  data() {
    return {
      sellerHouseRuleSectorId:'',
      fullscreenLoading: false,
      title: '',
      content: '',
      releaseStatus: 2,
      releaseDate: null,
      sellerHouseRuleSectorList:[],
      editorOption: {
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              // ['blockquote', 'code-block'],
              [{ 'header': 1 }, { 'header': 2 }],
              [{ 'list': 'ordered' }, { 'list': 'bullet' }],
              // [{ 'script': 'sub' }, { 'script': 'super' }],
              // [{ 'indent': '-1' }, { 'indent': '+1' }],
              // [{ 'direction': 'rtl' }],
              // [{ 'size': ['small', false, 'large', 'huge'] }],
              // [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
              [{ 'color': [] }, { 'background': [] }],
              // [{ 'font': [] }],
              [{ 'align': '' }, { 'align': 'center' }, { 'align': 'right' }, { 'align': 'justify' }],
              ['clean'],
              ['image'], // 'link', 'video'
            ],
            handlers: {
              'image': this.imgHandler,
            }
          },
          table: {
            // table module options
            cellSelectionOnClick: true // true: cell selection on click, false: cell selection with CTRL key
          },
          // add keyboard bindings in Keyboard options
          keyboard: {
            // Since Quill’s default handlers are added at initialization, the only way to prevent them is to add yours in the configuration.
            bindings: {
              backspace: {
                key: 'backspace',
                handler: function (range, keycontext) {
                  return TableModule.keyboardHandler(this.quill, 'backspace', range, keycontext);
                }
              },
              delete: {
                key: 'delete',
                handler: function (range, keycontext) {
                  return TableModule.keyboardHandler(this.quill, 'delete', range, keycontext);
                }
              },
              undo: {
                shortKey: true,
                key: 'z',
                handler: function (range, keycontext) {
                  return TableModule.keyboardHandler(this.quill, 'undo', range, keycontext);
                }
              },
              redo: {
                shortKey: true,
                shiftKey: true,
                key: 'z',
                handler: function (range, keycontext) {
                  return TableModule.keyboardHandler(this.quill, 'redo', range, keycontext);
                }
              }
            }
          }
        },
        placeholder: '请输入内容',
        readOnly: Boolean(this.$route.params.sid),
      },
      dialogVisible: false,
      editDateEnable: false,
    };
  },
  computed: {
    inputEl() {
      return this.$refs.fileInput;
    },
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
    isShow() {
      return Boolean(this.$route.params.sid);
    },
    isEdit() {
      return Boolean(this.$route.params.id);
    },
  },
  async created(){
    let res = await getRuleSectorList();

    if (res.data && res.data.data) {
      this.sellerHouseRuleSectorList = res.data.data.map(item => {
        return {
          value: item.sellerHouseRuleSectorId,
          label: item.name,
          children: item.children.map(child => {
            return {
              value: child.sellerHouseRuleSectorId,
              label: child.name,
            };
          }),
        };
      });
    }
  },
  mounted() {
    const id = this.$route.params.sid || this.$route.params.id;
    if (id) {
      getRuleDetail({
        id,
      }).then(res => {
        console.error(res,'rr')
        if (res.data && res.data.data) {
          this.title = res.data.data.title;
          this.content = res.data.data.content;
          this.releaseDate = res.data.data.publishTime;
          this.sellerHouseRuleSectorId = res.data.data.sellerHouseRuleSectorId;
          if (this.releaseDate > Date.now()) {
            this.releaseStatus = 1;
            this.editDateEnable = true;
          } else {
            this.releaseStatus = 2;
            this.editDateEnable = false;
          }
        }
      })
    }
  },
  methods: {
    // onEditorBlur(quill) {
    //   console.log('editor blur!', quill)
    // },
    // onEditorFocus(quill) {
    //   console.log('editor focus!', quill)
    // },
    // onEditorReady(quill) {
    //   console.log('editor ready!', quill)
    // },
    // onEditorChange({ quill, html, text }) {
    //   console.log('editor change!', quill, html, text)
    //   this.content = html
    // }
    imgHandler() {
      this.inputEl.click();
    },
    async changeFile(e) {
      if (e && e.target && e.target.files && e.target.files.length > 0) {
        try {
          for (let i = e.target.files.length - 1; i >= 0; i--) {
            const file = e.target.files[i];
            if (!/\.(png|jpe?g|gif)(\?.*)?$/.test(String(file.name).toLowerCase())) {
              this.fullscreenLoading = false;
              this.$message.error('只能上传.jpg,.jpeg,.png,.gif文件');
              return;
            }
            if (file.size > 10 * 1024 * 1024) {
              this.fullscreenLoading = false;
              this.$message.error('图片太大了');
              return;
            }
            this.fullscreenLoading = true;
            const confRes = await fileUpload();
            const OSSClient = Client(confRes.data.data);
            const objectKey = `tmp/${new Date().getTime()}${Math.random()}.${file.name.split('.').pop()}`;
            const ossRes = await OSSClient.put(objectKey, file);
            const fileUrl = ossRes.res.requestUrls[0];
            this.insertImg(fileUrl);
          }
          this.fullscreenLoading = false;
        } catch (error) {
          this.fullscreenLoading = false;
          console.log(error);
          this.$message.error('图片上传失败，请稍后再试');
        }
      }
      e.target.value = '';
    },
    insertImg(fileUrl) {
      const pos = this.editor.getSelection().index;
      this.editor.insertEmbed(pos, 'image', fileUrl, { maxLength: '100%' });
    },
    submit() {
      if (!this.title) {
        this.$message('请输入标题');
        return;
      }
      if (!this.content) {
        this.$message('请输入内容');
        return;
      }
      if(this.releaseStatus == 1 && !this.releaseDate){ //定时发布
        this.$message('请选择发布时间内容');
        return;
      }
      if(!this.sellerHouseRuleSectorId){
        this.$message('请选择规则板块');
        return;
      }

      ruleSave({
        sellerHouseRuleId: this.$route.params.id,
        publishTime: this.releaseStatus==2?Date.now():this.releaseDate,
        title: this.title,
        content: this.content,
        // releaseStatus: this.releaseStatus,
        sellerHouseRuleSectorId:this.sellerHouseRuleSectorId
      }).then(res => {
        if (res.data && res.data.success) {
          this.$message.success('发布成功');
          this.$router.back();
        } else {
          this.$message.error(res.data.message || '系统异常');
        }
      })
    },
    preview() {
      this.dialogVisible = true;
    },
    dateFormat(time) {
      if (!time) {
        return '';
      }
      return utils.dateFormat(new Date(time), 'yyyy-MM-dd');
    },
    importWord() {
      this.$refs.wordInput.click();
    },
    async changeWordFile(e) {
      if (e && e.target && e.target.files && e.target.files.length > 0) {
        try {
          const file = e.target.files[0];
          if (!/\.(doc?x)(\?.*)?$/.test(String(file.name).toLowerCase())) {
            this.fullscreenLoading = false;
            this.$message.error('只能上传.doc,.docx文件');
            return;
          }
          if (file.size > 10 * 1024 * 1024) {
            this.$message.error('文件太大了');
            return;
          }
          this.fullscreenLoading = true;
          const fd = new FormData();
          fd.append('file', file);
          const res = await docxToHtml(fd);
          if (res.data && res.data.data) {
            this.content = res.data.data;
          }
          // this.content
          this.fullscreenLoading = false;
        } catch (error) {
          this.fullscreenLoading = false;
          console.log(error);
          this.$message.error('图片上传失败，请稍后再试');
        }
      }
      e.target.value = '';
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}

.tr {
  margin-top: 10px;
  text-align: right;
}

.ml10 {
  margin-left: 10px;
}

.mt20 {
  margin-top: 20px;
}

.file-input {
  display: none;
}

.title {
  font-size: 18px;
  font-weight: 500;
  line-height: 25px;
}
.date {
  margin-top: 6px;
  color: #CCCCCC;
  font-size: 13px;
  line-height: 18px;
}
</style>
<style>
.preview-bulletin {
  margin-top: 27px;
  overflow: hidden;
  font-size: 13px;
  line-height: 24px;
  white-space:pre-wrap;
}
.preview-bulletin .ql-direction-rtl {
  direction: rtl;
  text-align: inherit;
}
.preview-bulletin .ql-align-center {
  text-align: center;
}
.preview-bulletin .ql-align-justify {
  text-align: justify;
}
.preview-bulletin .ql-align-right {
  text-align: right;
}
.preview-bulletin img {
  max-width: 100% !important;
}
.preview-bulletin table {
  margin: 0 auto;
  border-collapse: collapse;
  border-spacing: 0;
}
.preview-bulletin .td-q {
  border: 1px solid #dcdfe6;
  padding: 2px 5px;
}
.ql-editor {
  min-height:400px;
}
.ql-toolbar.ql-snow {
  border-color: #DCDFE6;
  border-radius: 4px 4px 0 0;
}
.ql-container.ql-snow {
  border-color: #DCDFE6;
  border-radius: 0 0 4px 4px;
}
</style>
